export const STORE_DEFAULT_NAME = '__LSM__';
export const STORE_ACTION_NAME = '__LSM_NAME__';
export const PERSIST_OPTION = {
  NONE: 'none',
  ACTION: 'action',
  UNLOAD: 'beforeUnload',
} as const;
